module.exports = __webpack_public_path__ + "img/bg-left.fe0e9cbb.png";